import { Pipe, PipeTransform } from '@angular/core';

import { formatFileSize } from '../utils/file.utils';

/**
 * Convert a file size in bytes into a human-readable string with appropriate units (Bytes, KB, MB, GB, TB, PB)
 */
@Pipe({
  name: 'mibFileSize',
})
export class MibFileSizePipe implements PipeTransform {
  transform(bytes: number | null | undefined, decimals = 2): string {
    return formatFileSize(bytes, decimals);
  }
}
